import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { fetchTermGrades } from "../../reduxSlices/termGradesSlice";

const formatGrade = (value) => (value === null || value === undefined ? "-" : value);
const formatCredits = (value) =>
  value === null || value === undefined ? "-" : value;

const formatTermLabel = (term) => {
  if (!term) return "";
  const name = term.ses_termname || "";
  const start = term.ses_startdate
    ? new Date(term.ses_startdate).toLocaleDateString()
    : "";
  return start ? `${name} (${start})` : name;
};

const TermGrades = () => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.termGrades);
  const [selectedTermId, setSelectedTermId] = useState("");
console.log(data,"adatat")
  useEffect(() => {
    const studentId = window.localStorage.getItem("studentId");
    if (studentId) {
      dispatch(fetchTermGrades(studentId));
    }
  }, [dispatch]);

  const terms = useMemo(() => {
    if (!Array.isArray(data)) return [];
    const map = {};
    data.forEach((row) => {
      const termId = row._ses_term_value;
      if (!termId || map[termId]) return;
      map[termId] = row.term;
    });
    const list = Object.entries(map).map(([id, term]) => ({
      id,
      term,
    }));
    // sort descending by start date
    list.sort((a, b) => {
      const aDate = a.term?.ses_startdate
        ? new Date(a.term.ses_startdate).getTime()
        : 0;
      const bDate = b.term?.ses_startdate
        ? new Date(b.term.ses_startdate).getTime()
        : 0;
      return bDate - aDate;
    });
    return list;
  }, [data]);

  useEffect(() => {
    if (!selectedTermId && terms.length > 0) {
      setSelectedTermId(terms[0].id);
    }
  }, [terms, selectedTermId]);

  const rowsForSelectedTerm = useMemo(() => {
    if (!Array.isArray(data)) return [];
    return data.filter((row) => {
      if (!selectedTermId) return true;
      return String(row._ses_term_value) === String(selectedTermId);
    });
  }, [data, selectedTermId]);

  return (
    <Card
      elevation={3}
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        marginBottom: 24,
      }}
    >
      <CardHeader title="Term Grades" />
      <CardContent
        style={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        {loading ? (
          <div>Loading...</div>
        ) : error ? (
          <div>Error: {error}</div>
        ) : (
          <>
            {terms.length > 0 && (
              <FormControl
                variant="outlined"
                size="small"
                style={{
                  marginBottom: 12,
                  minWidth: 140,
                  width: 200,
                  alignSelf: "flex-start",
                }}
              >
                <InputLabel id="term-grades-term-label">Term</InputLabel>
                <Select
                  labelId="term-grades-term-label"
                  value={selectedTermId}
                  onChange={(e) => setSelectedTermId(e.target.value)}
                  label="Term"
                >
                  {terms.map((t) => (
                    <MenuItem key={t.id} value={t.id}>
                      {formatTermLabel(t.term)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            <TableContainer component={Paper} style={{ flex: 1 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Course ID</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Grade</TableCell>
                    <TableCell>Credits</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowsForSelectedTerm.map((row) => (
                    <TableRow key={row.ses_sessionid}>
                      <TableCell>{row.ses_course}</TableCell>
                      <TableCell>{row.ses_classname}</TableCell>
                      <TableCell>{formatGrade(row.ses_grade)}</TableCell>
                      <TableCell>{formatCredits(row.ses_creditsearned)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default TermGrades;
